import component from "./Slogan"
import mobile from "./MobileSlogan"

export default { 
    component, 
    urlHash: "",
    mobile, 
}